// extracted by mini-css-extract-plugin
export default {"strip":"TrustStrip_strip__T92Xd","badge":"TrustStrip_badge__-sNvp"};